import { Button, FormField, Select } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useRef, useState } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';
import DRPicker from '../../../../../components/DRPicker';
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelCheck from '../../../../../components/extras/SidePanelCheck';
import SelectCheck from '../../../../../components/selects/selectChecks';
import SelectUser from '../../../../../components/selects/selectUser';
import TableChecks from '../../../../../components/tables/tableChecks';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemCheck } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';


const pageSize = 10;

export const EDVChecksSearchPage = () => {
    const { menu, idUser, parameters } = useGlobalState();
    const mountedRef = useRef(false);

    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");

            if (id) {
                if (!mountedRef.current) {
                    mountedRef.current = true;
                }
                handleCheckGet(parseInt(id))
            } else {
                setCheck(undefined)
            }
        };
        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();
        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);
    const [checks, setChecks] = useState<ItemCheck[]>([]);
    const [check, setCheck] = useState<ItemCheck>();






    const handleCheckEval = (arg0: any, arg1: any): void => { }
    const handleCheckPending = (): void => { }


    const handleCheckGet = async (idRequest: Number) => {
        try {
            setCheck(undefined)
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/checks/requests/get',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    idRequest: idRequest
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setCheck(data.check);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const handleCheckSearch = async (filters: any) => {
        let body: Record<string, unknown> = {};
        body.orderBy = "dateSubmited"
        body.order = "desc"
        body.limit = 1000;
        body.columns = "idCheck, idRequest, [check], displayName, instructor, idInstructor, statusRequest, equipmentCheck, dateSubmited, dateAssigned, dateResult"

        let canGo = false;
        if (filters && filters.keyw) {
            body.keyw = filters.keyw.join(" ").trim().replace(/\s+/g, " ");
            canGo = true;
        }
        if (parameters) {
            if (parameters.idChecks) {
                body.idChecks = parameters.idChecks;
                canGo = true;
            }
            if (parameters.idUser && parameters.idUser > 0) {
                body.idUser = parameters.idUser;
                canGo = true;
            }
            if (parameters.idInstructor && parameters.idInstructor > 0) {
                body.idInstructor = parameters.idInstructor;
                canGo = true;
            }
            if ((parameters.statusRequest || parameters.statusRequest === 0) && parameters.statusRequest !== -10) {
                body.statusRequest = parameters.statusRequest;
                canGo = true;
            }

            if (parameters.startDate && parameters.startDate !== "") {
                body.dateSubmitedStart = parameters.startDate;
                canGo = true;
            }

            if (parameters.endDate && parameters.endDate !== "") {
                body.dateSubmitedEnd = parameters.endDate;
                canGo = true;
            }

        }

        //if (keyw.length >= 3) {
        if (canGo) {
            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/checks/requests/search',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify(body),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    if (data.checks) {
                        setChecks(data.checks);
                        console.log(data.checks)

                    }
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }
        }
    }
    // Define Tab type for Tabs component
    type Tab = {
        label: string;
        id: string;
        content: React.ReactNode;
    };
    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const paginated: ItemCheck[] = checks.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);
    return (
        <CustomAppLayout
            splitPanelOpen={!!check}
            onSplitPanelToggle={({ detail }) => !detail.open ? window.location.hash = 'edv/checks/search' : null}
            splitPanelSize={600}
            splitPanel={
                <SidePanelCheck Check={check} />
            }

            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={<Favorites />} //info={<Link onClick={() => setHelpOpen(!helpOpen)}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                        >
                            Buscar chequeos
                        </Header>

                        <SpaceBetween direction='vertical' size='xs'>
                            <SpaceBetween direction="vertical" size="xs">
                                <SpaceBetween direction="horizontal" size="xs">
                                    <FormField label="Chequeo">
                                        <SelectCheck single={false}
                                            tokenLimit={0}

                                            value={parameters.idChecks ?? []} onSelect={(data) => {
                                                const updatedParameters = {
                                                    ...parameters, // clone existing keys
                                                    idChecks: data, // add or update
                                                };
                                                setParameters(updatedParameters);
                                                setCheck(undefined)
                                            }}
                                        />
                                    </FormField>
                                    <FormField label="Piloto">
                                        <SelectUser value={parameters.idUser}
                                            onConfirm={(user) => {
                                                const updatedParameters = {
                                                    ...parameters, // clone existing keys
                                                    idUser: user?.idUser, // add or update
                                                };
                                                setParameters(updatedParameters);
                                                setCheck(undefined)
                                            }}
                                        />
                                    </FormField>
                                    <FormField label="Instructor">
                                        <SelectUser value={parameters.idInstructor}
                                            onConfirm={(user) => {
                                                const updatedParameters = {
                                                    ...parameters, // clone existing keys
                                                    idInstructor: user?.idUser, // add or update
                                                };
                                                setParameters(updatedParameters);
                                                setCheck(undefined)
                                            }}
                                        />
                                    </FormField>
                                </SpaceBetween>
                                <SpaceBetween direction="horizontal" size="xs">
                                    <FormField label="Estado">
                                        <Select
                                            options={[
                                                { value: "-10", label: "Indeterminado" },
                                                { value: "-2", label: "Expirado" },
                                                { value: "-1", label: "Anulado" },
                                                { value: "0", label: "Pendiente" },
                                                { value: "1", label: "Asignado" },
                                                { value: "2", label: "Rechazado" },
                                                { value: "3", label: "Aprobado" }
                                            ]}
                                            onChange={(event) => {
                                                setCheck(undefined)
                                                const updatedParameters = {
                                                    ...parameters, // clone existing keys
                                                    statusRequest: Number(event.detail.selectedOption.value)
                                                };
                                                setParameters(updatedParameters);

                                            }}
                                            selectedOption={
                                                parameters.statusRequest !== undefined ?
                                                    { value: String(parameters.statusRequest), label: parameters.statusRequest === -10 ? "Indeterminado" : parameters.statusRequest === -2 ? "Expirado" : parameters.statusRequest === -1 ? "Anulado" : parameters.statusRequest === 0 ? "Pendiente" : parameters.statusRequest === 1 ? "Asignado" : parameters.statusRequest === 2 ? "Rechazado" : parameters.statusRequest === 3 ? "Aprobado" : "" }
                                                    :
                                                    { value: "-10", label: "Indeterminado" }
                                            }
                                        />
                                    </FormField>
                                    <FormField label="Rango">
                                        <DRPicker
                                            start={parameters.startDate}
                                            end={parameters.endDate}
                                            onConfirm={(startDate, endDate) => {
                                                setCheck(undefined)
                                                const updatedParameters = { ...parameters, startDate: startDate, endDate: endDate, };
                                                setParameters(updatedParameters);
                                            }}
                                        />
                                    </FormField>
                                    <FormField label="&nbsp;">
                                        <Button style={{ root: btnIconForm }} onClick={() => {
                                            setCheck(undefined)
                                            handleCheckSearch(parameters)
                                        }
                                        }><Icon path={mdiMagnify} size={1} /></Button>
                                    </FormField>
                                </SpaceBetween>
                            </SpaceBetween>



                            <TableChecks checks={checks} onSelect={(item: ItemCheck) => window.location.hash = `edv/checks/search?id=${item.idRequest}`} />


                        </SpaceBetween>
                    </SpaceBetween>



                </>
            }
        />
    );
};

function getColor(hex: string): "green" | "blue" | "red" | "grey" | "severity-low" {
    switch (hex.toLowerCase()) {
        case "#00b000":
            return "green";
        case "#007cff":
            return "blue";
        case "#ff0000":
            return "red";
        case "#999999":
            return "severity-low";
        default:
            return "grey";
    }
}